import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { searchPaciente } from "../../api/apiService";
import Navbar from "../../components/Navbar";

const HomePSF = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  const navigate = useNavigate();

  const formatCPF = (cpf) => {
    return cpf
      .replace(/\D/g, "")
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{2})$/, "$1-$2");
  };

  const cleanCPF = (cpf) => cpf.replace(/\D/g, "");

  const formatTelefone = (telefone) => {
    const digits = telefone.replace(/\D/g, "");
    if (digits.length === 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else if (digits.length === 11) {
      return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
    return telefone;
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      setError("Digite um valor para buscar.");
      return;
    }

    const cleanedQuery = cleanCPF(searchQuery);
    setLoading(true);
    setError("");
    setSearchPerformed(false);
    try {
      const data = await searchPaciente(cleanedQuery);
      setResults(data ? [data] : []);
    } catch (err) {
      if (err.response && err.response.data) {
        const { field, message } = err.response.data;
        setError(`${field.toUpperCase()}: ${message}`);
      } else {
        setError("Erro ao buscar paciente. Tente novamente mais tarde.");
      }
    } finally {
      setSearchPerformed(true);
      setLoading(false);
    }
  };

  const handleNavigateToHome = (username) => {
    navigate(`/home?user=${username}`);
  };

  return (
    <>
      <Navbar />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Box
          padding="2rem"
          width="100%"
          maxWidth="100vw"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h4" mb={4}>
            Home PSF
          </Typography>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
            display="flex"
            gap={2}
            mb={4}
            width="100%"
          >
            <TextField
              label="Buscar por CPF"
              variant="outlined"
              name="cpf"
              value={searchQuery}
              onChange={(e) => setSearchQuery(formatCPF(e.target.value))}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Buscar"
              )}
            </Button>
          </Box>
          {error && (
            <Typography color="error" mb={2}>
              {error}
            </Typography>
          )}
          {results.length > 0 && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell>CPF</TableCell>
                    <TableCell>Telefone</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Endereço</TableCell>
                    <TableCell>UBS</TableCell>
                    <TableCell>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {results.map((paciente, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {paciente.nomeCompleto || "Nome não informado"}
                      </TableCell>
                      <TableCell>{formatCPF(paciente.cpf || "")}</TableCell>
                      <TableCell>
                        {formatTelefone(paciente.telefone || "")}
                      </TableCell>
                      <TableCell>
                        {paciente.email || "Email não informado"}
                      </TableCell>
                      <TableCell>
                        {paciente.endereco ? (
                          <>
                            {paciente.endereco}, {paciente.numero || "s/n"} -{" "}
                            {paciente.bairro || "Bairro não informado"},{" "}
                            {paciente.cidade || "Cidade não informada"}/
                            {paciente.estado || "Estado não informado"}
                          </>
                        ) : (
                          "Endereço não informado"
                        )}
                      </TableCell>
                      <TableCell>
                        {paciente.nomeUbs || "UBS não informada"}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleNavigateToHome(paciente.username)
                          }
                        >
                          Ir para Home
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {searchPerformed && !loading && results.length === 0 && (
            <Typography color="textSecondary" mt={2}>
              Nenhum resultado encontrado.
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default HomePSF;
